import { parsePhoneNumberFromString } from "libphonenumber-js/min";
export { isValidPhoneNumber } from "libphonenumber-js/min";

export const formatToE164 = (value: string) => {
  const phoneNumber = parsePhoneNumberFromString(value, "US");

  if (phoneNumber) {
    return phoneNumber.format("E.164");
  }

  return value;
};

export function formatPhoneNumber(phone: string) {
  const phoneNumber = parsePhoneNumberFromString(phone, "US");

  if (phoneNumber) {
    return `+${phoneNumber.countryCallingCode}${phoneNumber.formatNational()}`;
  }

  return phone;
}
